import React, { useEffect, useState } from 'react';
import { ReactComponent as CloudsRainHome } from '../../images/clouds-rain-home.svg';
import { useSelector } from 'react-redux';
import Actions from '../../actions/actions';

const NoStateLicense = ({ plural = false }) => {
  const coid = useSelector((redux) => redux?.user?.company?.coid);

  const [contactInfo, setContactInfo] = useState(null);

  useEffect(() => {
    async function fetchData() {
      setContactInfo(await Actions.fetchCompanyAdminContactInfo(coid));
    }
    fetchData().then((r) => r);
  }, [coid]);

  return (
    <div className="error-page" id="qa-no-state-license-page">
      <h1 className="headline">No State License{plural && 's'}</h1>
      <div>
        <p>Sorry you are not licensed in {plural ? 'any states' : 'this state'}.</p>
        <p>
          {contactInfo ? (
            <>
              Please contact {contactInfo.name} at{' '}
              <span id="contact-link">
                <a href={'mailto: ' + contactInfo.email}>{contactInfo.email}</a>
              </span>{' '}
              for more information.
            </>
          ) : (
            "Please contact your company's admin."
          )}
        </p>
      </div>
      <CloudsRainHome name="clouds-rain-home" className="clouds-rain-home-icon icon" />
    </div>
  );
};

export default NoStateLicense;
